/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-08-07 11:40:34
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-11-01 05:25:16
 */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Message } from "../models/message.model";
import { TransService } from "./trans.service";

@Injectable()
export class MessageService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/messages`;

  private _updatedMessage: BehaviorSubject<Message> = new BehaviorSubject(null);

  constructor(private transService: TransService, private http: HttpClient) {}

  createMessage(data) {
    return this.http.post(`${this.url}`, data);
  }

  getMessages(page: number, limit: number, celebId: string, type?: string) {
    return this.http.get(
      `${this.url}?page=${page}&limit=${limit}&type=${type ||
        ""}&celeb=${celebId || ""}&lang=${this.transService.lang}`
    );
  }

  getMessage(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateMessage(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteMessage(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  setCeleb(id: string, celebId: string) {
    return this.http.put(
      `${this.url}/${id}/set-celeb?lang=${this.transService.lang}`,
      {
        celeb: celebId
      }
    );
  }

  incViewCount(id: string) {
    return this.http.get(
      `${this.url}/${id}/inc-viewcount?lang=${this.transService.lang}`
    );
  }

  views(id: string) {
    return this.http.get(
      `${this.url}/${id}/views?lang=${this.transService.lang}`
    );
  }

  notifyUpdatedMessage(message: Message) {
    this._updatedMessage.next(message);
  }

  get updatedMessage$() {
    return this._updatedMessage.asObservable();
  }

  syncVimeo(id: string) {
    return this.http.get(
      `${this.url}/${id}/sync-vimeo?lang=${this.transService.lang}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/message.service.ts